import axios from "axios";
const baseUrl = process.env.VUE_APP_API_URL;

function getQueryString(params) {
    if (params == null) {
        return '';
    }
    return Object.keys(params)
        .map(key => `${key}=${params[key]}`)
        .join('&');
}

export default {
    async getCorporates(params = null) {
        let response = await axios.get(baseUrl + `/corporate/index?${getQueryString(params)}`);
        return response.data;
    },
    async getUsers(params = null) {
        let response = await axios.get(baseUrl + `/corporate-user/index?${getQueryString(params)}`);
        return response.data;
    },
    async getPrograms(params = null) {
        let response = await axios.get(baseUrl + `/corporate-program/index?${getQueryString(params)}`);
        return response.data;
    },
    async createUpdateProgram(data = null) {
        let response = await axios.post(baseUrl + `/corporate-program/create-update`, data);
        return response.data;
    },
    async getProgramDropdownItems(data = null) {
        let response = await axios.post(baseUrl + `/corporate-program/dropdown-items`, data);
        return response.data;
    },
    async getCorporatePrograms(params = null) {
        let response = await axios.get(baseUrl + `/corporate-program/corporate-programs?${getQueryString(params)}`);
        return response.data;
    },
    async createCorporateProgram(data = null) {
        let response = await axios.post(baseUrl + `/corporate-program/create-corporate-programs`, data);
        return response.data;
    },
    async deleteCorporateProgram(data = null) {
        let response = await axios.post(baseUrl + `/corporate-program/delete-corporate-programs`, data);
        return response.data;
    },
    async getProgramsDropdown(params = null) {
        let response = await axios.get(baseUrl + `/corporate-program/programs-dropdown?${getQueryString(params)}`);
        return response.data;
    }
}
